import { useEffect } from "react";

const WhatsAppRedirect = () => {
  useEffect(() => {
    window.location.href = "https://whatsapp.com/channel/0029VaAp7gyIiRop6jdwJZ06";
  }, []);

  return null;
};

export default WhatsAppRedirect;